import React, { useState, useEffect, createContext, useContext } from 'react';
import './App.css';
import CheckoutPage from './pages/CheckoutPage';
import axios from 'axios';
import Slider from 'react-slick';
import { motion } from 'framer-motion';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Link, useNavigate, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import AboutSection from './components/AboutSection';
import WhatsHot from './components/WhatsHot';
import FeaturedSection from './components/FeaturedSection';
import BestSellersSection from './components/BestSellersSection';
import Navbar from './components/Navbar';
import ProductDetailsPage from './pages/ProductDetailsPage';
import Topwear from './components/Topwear';
import IndianWear from './components/IndianWear';
import Bottomwear from './components/Bottomwear';
import SportsWear from './components/SportsWear';
import FashionAccessories from './components/FashionAccessories';
import InnerwearSleepwear from './components/InnerwearSleepwear';
// New Women & Kids Category Pages
import IndianFusionWear from './components/IndianFusionWear';
import WesternWear from './components/WesternWear';
import LingerieSleepwear from './components/LingerieSleepwear';
import SportsActiveWear from './components/SportsActiveWear';
import WomenFashionAccessories from './components/WomenFashionAccessories';
import BoysClothing from './components/BoysClothing';
import GirlsClothing from './components/GirlsClothing';
import InfantsClothing from './components/InfantsClothing';

// Men's Subcategories
import TShirts from './components/MensSubcategories/TShirts';
import CasualShirts from './components/MensSubcategories/CasualShirts';
import FormalShirts from './components/MensSubcategories/FormalShirts';
import Sweatshirts from './components/MensSubcategories/Sweatshirts';
import Sweaters from './components/MensSubcategories/Sweaters';
import Jackets from './components/MensSubcategories/Jackets';
import Suits from './components/MensSubcategories/Suits';
import BlazersCoats from './components/MensSubcategories/BlazersCoats';
import RainJackets from './components/MensSubcategories/RainJackets';
import Jeans from './components/MensSubcategories/Jeans';
import CasualTrousers from './components/MensSubcategories/CasualTrousers';
import FormalTrousers from './components/MensSubcategories/FormalTrousers';
import Shorts from './components/MensSubcategories/Shorts';
import TrackPantsJoggers from './components/MensSubcategories/TrackPantsJoggers';
import KurtasKurtaSets from './components/MensSubcategories/KurtasKurtaSets';
import Sherwanis from './components/MensSubcategories/Sherwanis';
import NehruJackets from './components/MensSubcategories/NehruJackets';
import Dhotis from './components/MensSubcategories/Dhotis';
import ActiveTShirts from './components/MensSubcategories/SportsActiveWear/ActiveTShirts';
import TrackPantsShorts from './components/MensSubcategories/SportsActiveWear/TrackPantsShorts';
import Tracksuits from './components/MensSubcategories/SportsActiveWear/Tracksuits';
import JacketsSweatshirts from './components/MensSubcategories/SportsActiveWear/JacketsSweatshirts';
import Swimwear from './components/MensSubcategories/SportsActiveWear/Swimwear';
import BriefsTrunks from './components/MensSubcategories/InnerwearSleepwear/BriefsTrunks';
import Boxers from './components/MensSubcategories/InnerwearSleepwear/Boxers';
import Vests from './components/MensSubcategories/InnerwearSleepwear/Vests';
import SleepwearLoungewear from './components/MensSubcategories/InnerwearSleepwear/SleepwearLoungewear';
import Thermals from './components/MensSubcategories/InnerwearSleepwear/Thermals';
import TiesCufflinksPocketSquares from './components/MensSubcategories/FashionAccessories/TiesCufflinksPocketSquares';
import CapsHats from './components/MensSubcategories/FashionAccessories/CapsHats';
import MufflersScarvesGloves from './components/MensSubcategories/FashionAccessories/MufflersScarves Gloves';
// Admin Module
import {
  AdminDashboard,
  ProductManagement,
  OrderManagement,
  UserManagement,
  CacheManagement,
  AdminLayout
} from './admin';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Auth Context
const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem('user');
    return storedUser ? JSON.parse(storedUser) : null;
  });
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
    setLoading(false);
  }, [token]);

  const login = (userData, authToken) => {
    setUser(userData);
    setToken(authToken);
    localStorage.setItem('token', authToken);
    localStorage.setItem('user', JSON.stringify(userData));
    axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    delete axios.defaults.headers.common['Authorization'];
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

// Loading Component
const LoadingSpinner = ({ size = 'md', text = 'Loading...' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12'
  };

  return (
    <div className="flex flex-col items-center justify-center py-8">
      <div className={`${sizeClasses[size]} border-4 border-blue-200 border-t-4 border-t-blue-600 rounded-full animate-spin`}></div>
      <p className="mt-4 text-gray-600 animate-pulse">{text}</p>
    </div>
  );
};
  // Private Route Component
const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <LoadingSpinner />;
  }
  
  if (!user) {
    return <Navigate to="/login" />;
  }
  
  return children;
};
// Promotional Banner Component
const PromoBar = () => {
  const [showBanner, setShowBanner] = useState(true);
  const [showModal, setShowModal] = useState(false);
  
  if (!showBanner) return null;
  
  return (
    <>
      <div className="bg-black text-white py-2 px-4 relative z-50">
        <div className="container mx-auto">
          <div className="flex items-center justify-center relative">
            <button 
              onClick={() => setShowModal(true)}
              className="flex items-center space-x-2 text-sm font-semibold hover:opacity-80 transition-opacity"
            >
              <span>FREE DELIVERY, RETURN & EXCHANGE</span>
              <svg 
                className="w-4 h-4" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            <button 
              onClick={() => setShowBanner(false)}
              className="absolute right-0 hover:bg-white/20 p-1 rounded transition-colors"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Modal Overlay */}
      {showModal && (
        <div className="fixed inset-0 bg-black/50 z-[100] flex items-start justify-center pt-20 px-4">
          <div className="bg-white rounded-lg max-w-5xl w-full p-8 relative animate-fade-in">
            <button 
              onClick={() => setShowModal(false)}
              className="absolute top-4 right-4 p-2 hover:bg-gray-100 rounded transition-colors"
            >
              <svg className="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {/* Sign Up Section */}
              <div>
                <h3 className="text-lg font-bold mb-4 uppercase">SIGN UP & GET 10% OFF</h3>
                <p className="text-sm text-gray-700 mb-4">
                  Members get more! Like a 10% discount voucher, early access to the sale and access to limited edition products. Sign up now!
                </p>
                <a href="/register" className="text-sm font-bold underline hover:no-underline">
                  LEARN MORE
                </a>
              </div>

              {/* Delivery Section */}
              <div>
                <h3 className="text-lg font-bold mb-4 uppercase">FREE DELIVERY, RETURN & EXCHANGE</h3>
                <div className="text-sm text-gray-700 space-y-3">
                  <p>Spend over ₹1000/- and your delivery is FREE!</p>
                  <p>For all orders, Return & Exchange is offered for free.</p>
                  <p>Delivery times for Delhi, Gurgaon: 1-2 Days</p>
                  <div className="space-y-2 mt-4">
                    <a href="#" className="block font-bold underline hover:no-underline">
                      READ MORE ON DELIVERY
                    </a>
                    <a href="#" className="block font-bold underline hover:no-underline">
                      READ MORE ON RETURN
                    </a>
                    <a href="#" className="block font-bold underline hover:no-underline">
                      READ MORE ON EXCHANGE
                    </a>
                  </div>
                </div>
              </div>

              {/* Students Section */}
              <div>
                <h3 className="text-lg font-bold mb-4 uppercase">STUDENTS GET 15% OFF</h3>
                <p className="text-sm text-gray-700 mb-4">
                  For instant access to this discount simply join now and verify your student status with UNiDAYS!
                </p>
                <a href="/register" className="text-sm font-bold underline hover:no-underline">
                  JOIN NOW
                </a>
              </div>

              {/* Terms Section */}
              <div>
                <h3 className="text-lg font-bold mb-4 uppercase">IMPORTANT ADICLUB TERMS AND CONDITIONS UPDATE</h3>
                <p className="text-sm text-gray-700 mb-4">
                  We've recently updated the adiclub terms & conditions. Review the revised conditions here.
                </p>
                <a href="#" className="text-sm font-bold underline hover:no-underline">
                  READ MORE
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// Countdown Timer Component
const CountdownTimer = ({ targetDate }) => {
  const [timeLeft, setTimeLeft] = useState({ hours: 0, minutes: 0, seconds: 0 });
  
  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const target = new Date(targetDate).getTime();
      const distance = target - now;
      
      if (distance < 0) {
        clearInterval(timer);
        return;
      }
      
      setTimeLeft({
        hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000)
      });
    }, 1000);
    
    return () => clearInterval(timer);
  }, [targetDate]);
  
  return (
    <div className="flex flex-col items-center justify-center space-y-2">
      <span className="text-sm font-medium uppercase tracking-wide">Sale Starts In:</span>
      <div className="flex space-x-2">
        {[{ label: 'Hours', value: timeLeft.hours }, { label: 'Min', value: timeLeft.minutes }, { label: 'Sec', value: timeLeft.seconds }].map((unit, idx) => (
          <div key={idx} className="bg-black/30 backdrop-blur-sm px-3 py-2 rounded-lg">
            <div className="text-2xl font-bold">{String(unit.value).padStart(2, '0')}</div>
            <div className="text-xs opacity-80">{unit.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

// Enhanced Header Component
const Header = () => {
  const { user, token, logout } = useAuth();
  const [cartItems, setCartItems] = useState([]);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [showSearch, setShowSearch] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const { cartRefreshKey } = useCartRefresh();
  const navigate = useNavigate();

  // Handle scroll to hide/show navbar
  useEffect(() => {
    const controlNavbar = () => {
      const currentScrollY = window.scrollY;
      
      if (currentScrollY < lastScrollY || currentScrollY < 50) {
        // Scrolling up or at top
        setIsVisible(true);
      } else if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // Scrolling down
        setIsVisible(false);
        setShowSearch(false); // Close search when hiding navbar
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', controlNavbar);
    return () => window.removeEventListener('scroll', controlNavbar);
  }, [lastScrollY]);

  const fetchCart = async () => {
    if (user) {
      try {
        const config = { headers: { Authorization: `Bearer ${token}` } };
        const response = await axios.get(`${API}/cart`, config);
        setCartItems(response.data.items || []);
      } catch (error) {
        console.error('Error fetching cart:', error);
      }
    }
  };

  useEffect(() => {
    fetchCart();
  }, [user, cartRefreshKey]);

  const cartItemCount = cartItems.reduce((total, item) => total + item.quantity, 0);

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/products?search=${encodeURIComponent(searchQuery)}`);
      setSearchQuery('');
      setShowSearch(false);
    }
  };

  return (
    <>
      <PromoBar />
      <header className={`bg-white text-black shadow-2xl sticky top-0 z-40 backdrop-blur-sm transition-transform duration-300 ${
        isVisible ? 'translate-y-0' : '-translate-y-full'
      }`}>
        <div className="container mx-auto px-4 py-3">
          <div className="flex justify-between items-center">
            {/* Logo */}
            <div className="flex items-center space-x-3 cursor-pointer group" onClick={() => navigate('/')}>
              <div className="w-10 h-10 bg-black rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                <span className="text-white font-bold text-xl">H</span>
              </div>
              <h1 className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-black to-gray-700 bg-clip-text text-transparent">
                House of PM
              </h1>
            </div>
            
            {/* Main Navigation */}
            <nav className="hidden lg:flex space-x-6 xl:space-x-8">
              <Link to="/" className="text-sm font-semibold hover:text-gray-600 transition-all duration-300 relative group uppercase tracking-wide">
                Home
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-black transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link to="/products?category=Electronics" className="text-sm font-semibold hover:text-gray-600 transition-all duration-300 relative group uppercase tracking-wide">
                Electronics
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-black transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link to="/products?category=Fashion" className="text-sm font-semibold hover:text-gray-600 transition-all duration-300 relative group uppercase tracking-wide">
                Fashion
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-black transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link to="/products?category=Accessories" className="text-sm font-semibold hover:text-gray-600 transition-all duration-300 relative group uppercase tracking-wide">
                Accessories
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-black transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link to="/products?category=Sports" className="text-sm font-semibold hover:text-gray-600 transition-all duration-300 relative group uppercase tracking-wide">
                Sports
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-black transition-all duration-300 group-hover:w-full"></span>
              </Link>
              {user?.role === 'admin' && (
                <Link to="/admin" className="text-sm font-semibold hover:text-red-600 transition-all duration-300 relative group uppercase tracking-wide">
                  Admin
                  <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-red-600 transition-all duration-300 group-hover:w-full"></span>
                </Link>
              )}
            </nav>
            
            {/* Right Section */}
            <div className="flex items-center space-x-4">
              {/* Search Button */}
              <button
                onClick={() => setShowSearch(!showSearch)}
                className="p-2 hover:bg-gray-100 rounded-lg transition-all duration-300"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </button>
              
              {user ? (
                <>
                  {/* Wishlist/Favorites */}
                  <button className="p-2 hover:bg-gray-100 rounded-lg transition-all duration-300 hidden md:block">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                    </svg>
                  </button>
                  
                  {/* Cart */}
                  <Link to="/cart" className="relative p-2 hover:bg-gray-100 rounded-lg transition-all duration-300">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                    </svg>
                    {cartItemCount > 0 && (
                      <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-bold">
                        {cartItemCount}
                      </span>
                    )}
                  </Link>
                  
                  {/* User Menu */}
                  <div className="hidden md:flex items-center space-x-3">
                    <span className="text-xs opacity-80">{user.full_name}</span>
                    <button onClick={logout} className="text-xs hover:text-gray-600 transition-colors">
                      Logout
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <Link to="/login" className="text-sm font-semibold hover:text-gray-600 transition-colors hidden md:block">
                    Login
                  </Link>
                  <Link to="/register" className="bg-black text-white px-4 py-2 rounded font-semibold text-sm hover:bg-gray-800 transition-all duration-300">
                    Sign Up
                  </Link>
                </>
              )}
            </div>
          </div>
          
          {/* Search Bar Dropdown */}
          {showSearch && (
            <div className="mt-4 pb-2">
              <form onSubmit={handleSearch} className="max-w-2xl mx-auto">
                <div className="relative">
                  <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Search for products..."
                    className="w-full px-4 py-3 pl-10 bg-gray-100 border border-gray-300 rounded-lg text-black placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent"
                    autoFocus
                  />
                  <svg className="absolute left-3 top-3.5 w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </div>
              </form>
            </div>
          )}
        </div>
      </header>
      
      {/* Grey Info Strip */}
      <div className="bg-gray-200 text-black py-2 px-4 text-center">
        <p className="text-xs md:text-sm font-semibold tracking-wide">
          NEXT-GEN GST REFORM: NEW GST RATES NOW IN EFFECT ON APPLICABLE PRODUCTS
        </p>
      </div>
    </>
  );
};

// Add hero images array - Cloudinary URLs
const heroImages = [
  'https://res.cloudinary.com/deejvhfyh/image/upload/v1763639459/heroes/hero1.jpg',
  'https://res.cloudinary.com/deejvhfyh/image/upload/v1763639460/heroes/hero2.jpg',
  'https://res.cloudinary.com/deejvhfyh/image/upload/v1763639461/heroes/hero3.jpg',
  'https://res.cloudinary.com/deejvhfyh/image/upload/v1763639462/heroes/hero4.jpg',
  'https://res.cloudinary.com/deejvhfyh/image/upload/v1763639464/heroes/hero5.jpg',
  'https://res.cloudinary.com/deejvhfyh/image/upload/v1763639465/heroes/hero6.jpg'
];

// Update hero slider settings for horizontal slide and larger height
const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 800,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  fade: false, // horizontal slide
  arrows: false
};

// Enhanced Home Page
const HomePage = () => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isPlaying, setIsPlaying] = useState(true);
  const [sliderRef1, setSliderRef1] = useState(null);
  const [sliderRef2, setSliderRef2] = useState(null);
  const [sliderRef3, setSliderRef3] = useState(null);
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    Promise.all([fetchProducts(), fetchCategories()]).finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    let interval;
    if (isPlaying && sliderRef1 && sliderRef2 && sliderRef3) {
      interval = setInterval(() => {
        sliderRef1.slickNext();
        sliderRef2.slickNext();
        sliderRef3.slickNext();
      }, 2000);
    }
    return () => clearInterval(interval);
  }, [isPlaying, sliderRef1, sliderRef2, sliderRef3]);

  const fetchProducts = async () => {
    try {
      const response = await axios.get(`${API}/products?limit=6`);
      setProducts(response.data);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${API}/categories`);
      setCategories(response.data);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  if (loading) {
    return <LoadingSpinner size="lg" text="Loading House of PM Store..." />;
  }

  return (
    <div className="min-h-screen bg-white">
      {/* Black Friday Banner */}
      <section className="relative bg-black text-white py-8 md:py-12 overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: 'url(https://res.cloudinary.com/deejvhfyh/image/upload/v1763639457/banners/black-friday-banner.jpg)' }}
        >
          <div className="absolute inset-0 bg-black/50"></div>
        </div>
        <div className="container mx-auto px-4 text-center relative z-10">
          <h1 className="text-lg md:text-2xl lg:text-3xl font-black mb-2 uppercase tracking-tight drop-shadow-2xl">
            BLACK FRIDAY STARTS
            <br />
            EARLY FOR MEMBERS
          </h1>
          <div>
            <CountdownTimer targetDate="2025-11-29T00:00:00" />
          </div>
        </div>
      </section>

      {/* Hero Section - 3 Column Carousel */}
      <motion.section initial={{ opacity: 0, y: -40 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
        <div className="relative w-full mx-auto mb-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-0">
            {/* Left Column Carousel */}
            <div className="relative overflow-hidden h-[400px] md:h-[500px]">
              <Slider {...sliderSettings} ref={slider => setSliderRef1(slider)} asNavFor={sliderRef2}>
                {heroImages.slice(0, 2).map((img, idx) => (
                  <div key={idx} className="relative h-[400px] md:h-[500px]">
                    <img src={img} alt="Hero Left" className="w-full h-full object-cover" />
                  </div>
                ))}
              </Slider>
            </div>

            {/* Middle Column Carousel */}
            <div className="relative overflow-hidden h-[400px] md:h-[500px] hidden md:block">
              <Slider {...sliderSettings} ref={slider => setSliderRef2(slider)} asNavFor={sliderRef1}>
                {heroImages.slice(2, 4).map((img, idx) => (
                  <div key={idx} className="relative h-[400px] md:h-[500px]">
                    <img src={img} alt="Hero Middle" className="w-full h-full object-cover" />
                  </div>
                ))}
              </Slider>
            </div>

            {/* Right Column Carousel */}
            <div className="relative overflow-hidden h-[400px] md:h-[500px] hidden md:block">
              <Slider {...sliderSettings} ref={slider => setSliderRef3(slider)} asNavFor={sliderRef1}>
                {heroImages.slice(4).map((img, idx) => (
                  <div key={idx} className="relative h-[400px] md:h-[500px]">
                    <img src={img} alt="Hero Right" className="w-full h-full object-cover" />
                  </div>
                ))}
              </Slider>
            </div>
          </div>
          
          {/* Play/Pause Button */}
          <button
            onClick={() => {
              if (isPlaying) {
                sliderRef1?.slickPause();
                sliderRef2?.slickPause();
                sliderRef3?.slickPause();
              } else {
                sliderRef1?.slickPlay();
                sliderRef2?.slickPlay();
                sliderRef3?.slickPlay();
              }
              setIsPlaying(!isPlaying);
            }}
            className="absolute top-4 right-4 z-20 bg-white/90 hover:bg-white p-2 md:p-3 rounded-full shadow-lg transition-all duration-300"
          >
            {isPlaying ? (
              <svg className="w-4 h-4 md:w-6 md:h-6 text-black" fill="currentColor" viewBox="0 0 24 24">
                <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z" />
              </svg>
            ) : (
              <svg className="w-4 h-4 md:w-6 md:h-6 text-black" fill="currentColor" viewBox="0 0 24 24">
                <path d="M8 5v14l11-7z" />
              </svg>
            )}
          </button>
          
          {/* Overlayed CTA buttons */}
          <div className="absolute inset-0 flex flex-col items-center justify-end pb-6 md:pb-12 z-10 px-4 pointer-events-none">
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center items-center pointer-events-auto">
              <Link 
                to="/products" 
                className="group bg-white text-black px-6 py-2 md:px-10 md:py-4 rounded font-bold text-sm md:text-lg hover:bg-gray-200 transition-all duration-300 transform hover:scale-105 hover:shadow-2xl uppercase tracking-wide"
              >
                <span>Shop Now</span>
              </Link>
              <Link 
                to="/register" 
                className="border-2 border-white text-white px-6 py-2 md:px-10 md:py-4 rounded font-bold text-sm md:text-lg hover:bg-white hover:text-black transition-all duration-300 transform hover:scale-105 uppercase tracking-wide"
              >
                Join Free
              </Link>
            </div>
          </div>
        </div>
      </motion.section>

      {/* Best Sellers Section */}
      <BestSellersSection />

      {/* Featured Section */}
      <FeaturedSection />

      

      {/* What's Hot Section */}
      <WhatsHot products={products} />

      

      {/* Featured Collections Grid */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Large Featured Card */}
            <div className="md:col-span-2 relative overflow-hidden rounded-2xl group cursor-pointer h-96" onClick={() => navigate('/products?category=Sports')}>
              <img src="https://res.cloudinary.com/deejvhfyh/image/upload/v1763639461/heroes/hero3.jpg" alt="Featured" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
              <div className="absolute bottom-8 left-8 text-white">
                <span className="bg-red-600 px-3 py-1 rounded text-sm font-bold mb-3 inline-block uppercase">New Collection</span>
                <h2 className="text-5xl font-black mb-4 uppercase">FIFA WORLD CUP 2026™</h2>
                <p className="text-xl mb-6 opacity-90">Official merchandise and exclusive designs</p>
                <button className="bg-white text-black px-8 py-3 rounded font-bold hover:bg-yellow-400 transition-colors uppercase">
                  Shop Now
                </button>
              </div>
            </div>
            
            {/* Smaller Featured Cards */}
            {[
              { img: 'https://res.cloudinary.com/deejvhfyh/image/upload/v1763639459/heroes/hero1.jpg', title: 'ELECTRONICS', subtitle: 'Latest Tech' },
              { img: 'https://res.cloudinary.com/deejvhfyh/image/upload/v1763639460/heroes/hero2.jpg', title: 'FASHION', subtitle: 'New Arrivals' }
            ].map((item, idx) => (
              <div key={idx} className="relative overflow-hidden rounded-2xl group cursor-pointer h-80" onClick={() => navigate(`/products?category=${item.title}`)}>
                <img src={item.img} alt={item.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
                <div className="absolute bottom-6 left-6 text-white">
                  <h3 className="text-3xl font-black mb-2 uppercase">{item.title}</h3>
                  <p className="text-lg opacity-90">{item.subtitle}</p>
                  <button className="mt-4 border-2 border-white px-6 py-2 rounded font-bold hover:bg-white hover:text-black transition-all uppercase text-sm">
                    Explore
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <AboutSection />
    </div>
  );
};

// Enhanced Product Card Component
const EnhancedProductCard = ({ product }) => {
  const { user, token } = useAuth();
  const [addingToCart, setAddingToCart] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const { refreshCart } = useCartRefresh(); // custom hook to trigger cart refresh
  const navigate = useNavigate();
  const addToCart = async (e) => {
    e.stopPropagation();
    if (!user) {
      alert('Please login to add items to cart');
      return;
    }
    setAddingToCart(true);
    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };
      await axios.post(`${API}/cart/add`, {
        product_id: product._id,
        quantity: 1
      }, config);
      if (refreshCart) refreshCart(); // trigger cart update in header
    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('Error adding product to cart');
    } finally {
      setAddingToCart(false);
    }
  };

  return (
    <div 
      onClick={() => navigate(`/product/${product._id}`)}
      className="group bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-500 transform hover:scale-105 border border-gray-100 hover:border-blue-200 cursor-pointer"
    >
      <div className="relative overflow-hidden">
        {!imageLoaded && (
          <div className="w-full h-64 bg-gradient-to-r from-gray-200 to-gray-300 animate-pulse flex items-center justify-center">
            <div className="text-gray-400">Loading...</div>
          </div>
        )}
        <img 
          src={product.image_url} 
          alt={product.name}
          className={`w-full h-64 object-cover group-hover:scale-110 transition-transform duration-700 ${!imageLoaded ? 'hidden' : ''}`}
          onLoad={() => setImageLoaded(true)}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        
        {/* Stock Badge */}
        <div className="absolute top-4 left-4 right-4 flex justify-between items-start">
          <div className="flex flex-col gap-2">
            {product.stock < 5 && product.stock > 0 && (
              <span className="bg-red-600 text-white px-3 py-1 rounded text-xs font-bold uppercase">
                🔥 Limited
              </span>
            )}
            {product.price < 1000 && (
              <span className="bg-gradient-to-r from-yellow-400 to-orange-500 text-black px-3 py-1 rounded text-xs font-bold uppercase">
                70% OFF
              </span>
            )}
          </div>
          <span className={`px-3 py-1 rounded text-xs font-semibold backdrop-blur-sm ${
            product.stock > 10 
              ? 'bg-green-500/90 text-white' 
              : product.stock > 0 
                ? 'bg-yellow-500/90 text-white'
                : 'bg-red-500/90 text-white'
          }`}>
            {product.stock > 0 ? `${product.stock} Left` : 'Sold Out'}
          </span>
        </div>
      </div>
      
      <div className="p-6">
        <div className="mb-3">
          <span className="text-xs font-semibold text-blue-600 bg-blue-50 px-2 py-1 rounded-full">
            {product.category}
          </span>
        </div>
        
        <h3 className="font-bold text-xl text-gray-800 mb-3 group-hover:text-blue-600 transition-colors line-clamp-2">
          {product.name}
        </h3>
        
        <p className="text-gray-600 text-sm mb-4 line-clamp-2 leading-relaxed">
          {product.description}
        </p>
        
        <div className="flex justify-between items-center mb-4">
          <div className="flex items-center space-x-2">
            <span className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              ₹{product.price}
            </span>
            <span className="text-lg text-gray-400 line-through">₹{(product.price * 1.2).toFixed(0)}</span>
          </div>
          <div className="flex text-yellow-400">
            {[...Array(5)].map((_, i) => (
              <svg key={i} className="w-4 h-4 fill-current" viewBox="0 0 20 20">
                <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"/>
              </svg>
            ))}
          </div>
        </div>
        
        <button
          onClick={addToCart}
          disabled={addingToCart || product.stock === 0}
          className={`w-full py-3 px-6 rounded-xl font-semibold transition-all duration-300 transform hover:scale-105 ${
            product.stock === 0
              ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
              : addingToCart
                ? 'bg-blue-400 text-white cursor-wait'
                : 'bg-gradient-to-r from-blue-600 to-purple-600 text-white hover:from-blue-700 hover:to-purple-700 shadow-lg hover:shadow-xl'
          }`}
        >
          {addingToCart ? (
            <div className="flex items-center justify-center space-x-2">
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              <span>Adding...</span>
            </div>
          ) : product.stock === 0 ? (
            'Out of Stock'
          ) : (
            <div className="flex items-center justify-center space-x-2">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-1.5 8H19" />
              </svg>
              <span>Add to Cart</span>
            </div>
          )}
        </button>
      </div>
    </div>
  );
};

// Enhanced Products Page
const ProductsPage = () => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Read category and search from URL if present
    const params = new URLSearchParams(window.location.search);
    const urlCategory = params.get('category');
    const urlSearch = params.get('search');
    
    if (urlCategory && urlCategory !== selectedCategory) {
      setSelectedCategory(urlCategory);
    }
    if (urlSearch && urlSearch !== searchTerm) {
      setSearchTerm(urlSearch);
    }
  }, [window.location.search]);

  useEffect(() => {
    fetchProducts();
    fetchCategories();
  }, [selectedCategory, searchTerm]);

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (selectedCategory) params.append('category', selectedCategory);
      if (searchTerm) params.append('search', searchTerm);
      
      const response = await axios.get(`${API}/products?${params}`);
      setProducts(response.data);
    } catch (error) {
      console.error('Error fetching products:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${API}/categories`);
      setCategories(response.data);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <div className="container mx-auto px-4 py-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold mb-4 bg-gradient-to-r from-gray-800 to-blue-600 bg-clip-text text-transparent">
            Premium Products
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {searchTerm ? `Search results for "${searchTerm}"` : 'Discover our extensive collection of high-quality products carefully selected for you'}
          </p>
        </div>
        
        {/* Enhanced Filters */}
        <div className="bg-white rounded-2xl p-8 mb-8 shadow-xl border border-gray-100">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="relative">
              <label className="block text-sm font-bold text-gray-700 mb-3">Search Products</label>
              <div className="relative">
                <input
                  type="text"
                  placeholder="Search for amazing products..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full px-4 py-3 pl-12 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                />
                <svg className="absolute left-4 top-3.5 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
            </div>
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-3">Category</label>
              <select
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 bg-white"
              >
                <option value="">All Categories</option>
                {categories.map(category => (
                  <option key={category.name} value={category.name}>{category.name} ({category.count})</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Products Grid */}
        {loading ? (
          <LoadingSpinner size="lg" text="Loading amazing products..." />
        ) : (
          <>
            <div className="flex justify-between items-center mb-8">
              <h2 className="text-2xl font-bold text-gray-800">
                {products.length} Products Found
                {selectedCategory && <span className="text-blue-600"> in {selectedCategory}</span>}
              </h2>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
              {products.map((product, idx) => (
                <EnhancedProductCard key={product._id} product={product} />
              ))}
            </div>
          </>
        )}

        {!loading && products.length === 0 && (
          <div className="text-center py-16">
            <div className="mb-6">
              <svg className="w-24 h-24 text-gray-300 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6-4h6m2 5.291A7.962 7.962 0 0112 15c-2.34 0-4.467-.881-6.08-2.33"/>
              </svg>
            </div>
            <h3 className="text-2xl font-bold text-gray-600 mb-2">No products found</h3>
            <p className="text-gray-500 mb-6">Try adjusting your search or filter criteria</p>
            <button
              onClick={() => {
                setSearchTerm('');
                setSelectedCategory('');
              }}
              className="bg-blue-600 text-white px-6 py-3 rounded-xl hover:bg-blue-700 transition-colors duration-300"
            >
              Clear Filters
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

// Enhanced Login Page
const LoginPage = () => {
  const { login, logout } = useAuth();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    // Load Google Sign-In script
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    script.onload = () => {
      if (window.google) {
        window.google.accounts.id.initialize({
          client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
          callback: handleGoogleSignIn
        });
        window.google.accounts.id.renderButton(
          document.getElementById('google-signin-button'),
          { 
            theme: 'filled_black',
            size: 'large',
            width: 350,
            text: 'signin_with',
            shape: 'rectangular'
          }
        );
      }
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const handleGoogleSignIn = async (response) => {
    try {
      setLoading(true);
      setError('');
      
      const result = await axios.post(`${API}/auth/google`, {
        credential: response.credential
      });
      
      if (result.data && result.data.access_token) {
        login(result.data.user, result.data.access_token);
        navigate('/');
      } else {
        setError('Google sign-in failed');
      }
    } catch (err) {
      console.error('Google sign-in error:', err);
      setError(err.response?.data?.message || 'Google sign-in failed');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${API}/auth/login`, formData);
      if (response.data && response.data.access_token) {
        setError(''); // Clear any previous error
        login(response.data.user, response.data.access_token);
        navigate('/');
      } else {
        setError('Login failed');
        logout();
      }
    } catch (error) {
      console.log('Login error (full):', error);
      setError(error.response?.data?.message || error.message || 'Login failed');
      logout();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full">
        <div className="bg-gray-800 rounded-2xl shadow-2xl p-8 border border-gray-700">
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-white font-bold text-2xl">H</span>
            </div>
            <h2 className="text-3xl font-bold bg-gradient-to-r from-white to-blue-400 bg-clip-text text-transparent">
              Welcome Back
            </h2>
            <p className="mt-2 text-gray-300">Sign in to your House of PM account</p>
          </div>
          
          <form onSubmit={handleSubmit} className="space-y-6">
            {error && (
              <div className="bg-red-50 border-l-4 border-red-400 p-4 rounded-lg">
                <div className="flex">
                  <svg className="w-5 h-5 text-red-400 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                  </svg>
                  <span className="text-red-700 text-sm">{error}</span>
                </div>
              </div>
            )}
            
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-2">Email Address</label>
              <input
                type="email"
                required
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                placeholder="Enter your email"
              />
            </div>
            
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-2">Password</label>
              <input
                type="password"
                required
                value={formData.password}
                onChange={(e) => setFormData({...formData, password: e.target.value})}
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                placeholder="Enter your password"
              />
            </div>
            
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-3 px-6 rounded-xl font-bold hover:from-blue-700 hover:to-purple-700 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? (
                <div className="flex items-center justify-center space-x-2">
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  <span>Signing In...</span>
                </div>
              ) : (
                'Sign In'
              )}
            </button>
          </form>
          
          <div className="relative my-6">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-600"></div>
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-4 bg-gray-800 text-gray-400">Or continue with</span>
            </div>
          </div>
          
          <div id="google-signin-button" className="flex justify-center"></div>
          
          <div className="text-center mt-6">
            <p className="text-gray-300">
              Don't have an account? 
              <Link to="/register" className="text-blue-400 hover:text-blue-300 font-semibold ml-1 hover:underline">
                Sign up
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

// Enhanced Register Page
const RegisterPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    full_name: '',
    phone: '',
    address: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    // Load Google Sign-In script
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    script.onload = () => {
      if (window.google) {
        window.google.accounts.id.initialize({
          client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
          callback: handleGoogleSignUp
        });
        window.google.accounts.id.renderButton(
          document.getElementById('google-signup-button'),
          { 
            theme: 'filled_black',
            size: 'large',
            width: 350,
            text: 'signup_with',
            shape: 'rectangular'
          }
        );
      }
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const handleGoogleSignUp = async (response) => {
    try {
      setLoading(true);
      setError('');
      
      const result = await axios.post(`${API}/auth/google`, {
        credential: response.credential
      });
      
      if (result.data && result.data.access_token) {
        login(result.data.user, result.data.access_token);
        navigate('/');
      } else {
        setError('Google sign-up failed');
      }
    } catch (err) {
      console.error('Google sign-up error:', err);
      setError(err.response?.data?.message || 'Google sign-up failed');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    console.log('Submitting registration:', formData);

    try {
      const response = await axios.post(`${API}/auth/register`, formData);
      console.log('Registration response:', response);
      login(response.data.user, response.data.access_token);
      navigate('/');
    } catch (error) {
      console.log('Registration error (full):', error);
      setError(error.response?.data?.message || error.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full">
        <div className="bg-gray-800 rounded-2xl shadow-2xl p-8 border border-gray-700">
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-white font-bold text-2xl">H</span>
            </div>
            <h2 className="text-3xl font-bold bg-gradient-to-r from-white to-blue-400 bg-clip-text text-transparent">
              Join House of PM
            </h2>
            <p className="mt-2 text-gray-300">Create your account and start shopping</p>
          </div>
          
          <form onSubmit={handleSubmit} className="space-y-6">
            {error && (
              <div className="bg-red-50 border-l-4 border-red-400 p-4 rounded-lg">
                <div className="flex">
                  <svg className="w-5 h-5 text-red-400 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                  </svg>
                  <span className="text-red-700 text-sm">{error}</span>
                </div>
              </div>
            )}
            
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-2">Full Name</label>
              <input
                type="text"
                required
                value={formData.full_name}
                onChange={(e) => setFormData({...formData, full_name: e.target.value})}
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                placeholder="Enter your full name"
              />
            </div>
            
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-2">Email Address</label>
              <input
                type="email"
                required
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                placeholder="Enter your email"
              />
            </div>
            
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-2">Password</label>
              <input
                type="password"
                required
                value={formData.password}
                onChange={(e) => setFormData({...formData, password: e.target.value})}
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                placeholder="Create a secure password"
              />
            </div>
            
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-2">Phone (Optional)</label>
              <input
                type="tel"
                value={formData.phone}
                onChange={(e) => setFormData({...formData, phone: e.target.value})}
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                placeholder="Enter your phone number"
              />
            </div>
            
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-2">Address (Optional)</label>
              <textarea
                value={formData.address}
                onChange={(e) => setFormData({...formData, address: e.target.value})}
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                placeholder="Enter your address"
                rows="3"
              />
            </div>
            
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-3 px-6 rounded-xl font-bold hover:from-blue-700 hover:to-purple-700 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? (
                <div className="flex items-center justify-center space-x-2">
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  <span>Creating Account...</span>
                </div>
              ) : (
                'Create Account'
              )}
            </button>
          </form>
          
          <div className="relative my-6">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-600"></div>
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-4 bg-gray-800 text-gray-400">Or continue with</span>
            </div>
          </div>
          
          <div id="google-signup-button" className="flex justify-center"></div>
          
          <div className="text-center mt-6">
            <p className="text-gray-300">
              Already have an account? 
              <Link to="/login" className="text-blue-400 hover:text-blue-300 font-semibold ml-1 hover:underline">
                Sign in
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

// Continue with other enhanced components...
const CartPage = () => {
  const { user, token } = useAuth();
  const navigate = useNavigate();
  const [cart, setCart] = useState({ items: [], total: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      fetchCart();
    }
  }, [user]);

  const fetchCart = async () => {
    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const response = await axios.get(`${API}/cart`, config);
      setCart(response.data);
    } catch (error) {
      console.error('Error fetching cart:', error);
    } finally {
      setLoading(false);
    }
  };

  const removeFromCart = async (productId) => {
    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };
      await axios.delete(`${API}/cart/remove/${productId}`, config);
      fetchCart();
    } catch (error) {
      console.error('Error removing from cart:', error);
    }
  };

  const proceedToCheckout = () => {
    if (cart.items.length === 0) {
      alert('Your cart is empty');
      return;
    }
    navigate('/checkout');
  };

  if (!user) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 flex items-center justify-center">
        <div className="text-center bg-white rounded-2xl p-12 shadow-2xl border border-gray-100 max-w-md">
          <div className="w-20 h-20 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Login Required</h2>
          <p className="text-gray-600 mb-6">Please login to view your shopping cart</p>
          <Link to="/login" className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-3 rounded-xl font-semibold hover:from-blue-700 hover:to-purple-700 transition-all duration-300 transform hover:scale-105">
            Login Now
          </Link>
        </div>
      </div>
    );
  }

  if (loading) {
    return <LoadingSpinner size="lg" text="Loading your cart..." />;
  }

  return (
    <div className="min-h-screen bg-white">
      <div className="container mx-auto px-4 py-8">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold bg-gradient-to-r from-gray-800 to-blue-600 bg-clip-text text-transparent mb-2">
            Shopping Cart
          </h1>
          <p className="text-gray-600">Review your items before checkout</p>
        </div>
        
        {cart.items.length === 0 ? (
          <div className="bg-gray-800 rounded-2xl p-12 text-center shadow-xl border border-gray-700 max-w-2xl mx-auto">
            <div className="w-24 h-24 bg-gray-700 rounded-full flex items-center justify-center mx-auto mb-6">
              <svg className="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-1.5 8H19" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Your cart is empty</h2>
            <p className="text-gray-600 mb-8">Discover amazing products and add them to your cart!</p>
            <Link to="/products" className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-3 rounded-xl font-semibold hover:from-blue-700 hover:to-purple-700 transition-all duration-300 transform hover:scale-105">
              Start Shopping
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2">
              <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
                <div className="p-6 bg-gradient-to-r from-blue-50 to-purple-50 border-b border-gray-100">
                  <h2 className="text-xl font-bold text-gray-800">Cart Items ({cart.items.length})</h2>
                </div>
                {cart.items.map((item, index) => (
                  <div key={index} className="p-6 border-b border-gray-100 last:border-b-0 hover:bg-gray-50 transition-colors duration-200">
                    <div className="flex items-center space-x-6">
                      <div className="w-20 h-20 bg-gradient-to-br from-blue-100 to-purple-100 rounded-xl flex-shrink-0 flex items-center justify-center">
                        <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                        </svg>
                      </div>
                      <div className="flex-1">
                        <h3 className="font-bold text-lg text-gray-800 mb-1">Product ID: {item.product_id}</h3>
                        <div className="flex items-center space-x-4 text-sm text-gray-600">
                          <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full font-medium">
                            Qty: {item.quantity}
                          </span>
                          <span className="font-semibold">₹{item.price} each</span>
                        </div>
                      </div>
                      <div className="text-right">
                        <p className="font-bold text-xl text-gray-800 mb-2">
                          ₹{(item.quantity * item.price).toFixed(2)}
                        </p>
                        <button
                          onClick={() => removeFromCart(item.product_id)}
                          className="text-red-600 hover:text-red-800 hover:bg-red-50 px-3 py-1 rounded-lg transition-all duration-200 text-sm font-medium"
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="lg:col-span-1">
              <div className="bg-white rounded-2xl shadow-xl p-6 sticky top-4 border border-gray-100">
                <h2 className="text-xl font-bold text-gray-800 mb-6">Order Summary</h2>
                
                <div className="space-y-4 mb-6">
                  <div className="flex justify-between text-gray-600">
                    <span>Subtotal:</span>
                    <span className="font-semibold">₹{cart.total.toFixed(2)}</span>
                  </div>
                  <div className="flex justify-between text-gray-600">
                    <span>Shipping:</span>
                    <span className="font-semibold text-green-600">Free</span>
                  </div>
                  <div className="flex justify-between text-gray-600">
                    <span>Tax:</span>
                    <span className="font-semibold">₹0.00</span>
                  </div>
                  <div className="border-t pt-4">
                    <div className="flex justify-between font-bold text-xl">
                      <span>Total:</span>
                      <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                        ₹{cart.total.toFixed(2)}
                      </span>
                    </div>
                  </div>
                </div>
                
                <button
                  onClick={proceedToCheckout}
                  className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-4 rounded-xl font-bold text-lg hover:from-blue-700 hover:to-purple-700 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
                >
                  Proceed to Checkout
                </button>
                
                <div className="mt-4 text-center">
                  <Link to="/products" className="text-blue-600 hover:text-blue-700 font-medium hover:underline">
                    ← Continue Shopping
                  </Link>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

// Enhanced Checkout Page
// const CheckoutPage = () => {
//   const { user, token } = useAuth();
//   const [cart, setCart] = useState({ items: [], total: 0 });
//   const [shippingAddress, setShippingAddress] = useState('');
//   const [processing, setProcessing] = useState(false);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     if (user) {
//       fetchCart();
//     }
//   }, [user]);

//   const fetchCart = async () => {
//     try {
//       const config = { headers: { Authorization: `Bearer ${token}` } };
//       const response = await axios.get(`${API}/cart`, config);
//       setCart(response.data);
//       if (user.address) {
//         setShippingAddress(user.address);
//       }
//     } catch (error) {
//       console.error('Error fetching cart:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const loadScript = (src) => {
//     return new Promise((resolve) => {
//       const script = document.createElement('script');
//       script.src = src;
//       script.onload = () => {
//         resolve(true);
//       };
//       script.onerror = () => {
//         resolve(false);
//       };
//       document.body.appendChild(script);
//     });
//   };

//   const initiatePayment = async () => {
//     if (!shippingAddress.trim()) {
//       alert('Please enter shipping address');
//       return;
//     }
//     setProcessing(true);
//     try {
//       // 1. Load Razorpay SDK
//       const res = await loadScript('https://checkout.razorpay.com/v1/checkout.js');
//       if (!res) {
//         alert('Razorpay SDK failed to load. Are you online?');
//         return;
//       }
//       // 2. Create Order on Backend
//       const config = { headers: { Authorization: `Bearer ${token}` } };
//       const orderResponse = await axios.post(`${API}/orders/create`, {
//         shipping_address: shippingAddress
//       }, config);
//       const { amount, id: order_id, currency, key: razorpayKey } = orderResponse.data;
//       // 3. Initialize Razorpay Options
//       const options = {
//         key: razorpayKey, 
//         amount: amount.toString(),
//         currency: currency,
//         name: "Franciium",
//         description: "Transaction for order",
//         order_id: order_id, // This is the order_id created in the backend
//         handler: async function (response) {
//           try {
//             // 4. Verify Payment on Backend
//             const verifyResponse = await axios.post(`${API}/orders/verify-payment`, {
//               razorpay_order_id: response.razorpay_order_id,
//               razorpay_payment_id: response.razorpay_payment_id,
//               razorpay_signature: response.razorpay_signature
//             }, config);
//             if (verifyResponse.data.status === 'success') {
//               alert('✅ Payment successful! Redirecting to orders...');
//               navigate('/orders');
//               if (useCartRefresh().refreshCart) useCartRefresh().refreshCart(); // Refresh cart count
//             }
//           } catch (error) {
//             console.error('Payment verification failed:', error);
//             alert('Payment verification failed. Please contact support.');
//           }
//         },
//         prefill: {
//           name: user.name,
//           email: user.email,
//           contact: user.phone || ''
//         },
//         theme: {
//           color: "#2563EB"
//         }
//       };
//       // 4. Open Razorpay
//       const paymentObject = new window.Razorpay(options);
//       paymentObject.open();
//     } catch (error) {
//       console.error('Payment initiation error:', error);
//       alert('Failed to initiate payment. Please try again.');
//     } finally {
//       setProcessing(false);
//     }
//   };

    // setProcessing(true);
    // try {
    //   const orderResponse = await axios.post(`${API}/orders/create`, {
    //     shipping_address: shippingAddress
    //   });

    //   // Demo payment simulation with enhanced UX
    //   alert('🎉 Demo Mode: Payment simulation starting...\n\nThis would normally open Razorpay payment gateway. For demo purposes, we\'ll simulate a successful payment.');
      
    //   setTimeout(async () => {
    //     try {
    //       const mockPaymentData = {
    //         razorpay_order_id: orderResponse.data.razorpay_order_id,
    //         razorpay_payment_id: 'pay_demo_' + Date.now(),
    //         razorpay_signature: 'demo_signature'
    //       };
          
    //       const verifyResponse = await axios.post(`${API}/orders/verify-payment`, mockPaymentData);
    //       if (verifyResponse.data.status === 'success') {
    //         alert('✅ Payment successful! Redirecting to orders...');
    //         navigate('/orders');
    //       }
    //     } catch (error) {
    //       console.error('Demo payment error:', error);
    //       alert('❌ Demo payment failed');
    //     }
    //   }, 2000);

    // } catch (error) {
    //   console.error('Payment initiation error:', error);
    //   alert('Failed to initiate payment');
    // } finally {
    //   setProcessing(false);
    // }
  // };

//   if (!user) {
//     return (
//       <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 flex items-center justify-center">
//         <div className="text-center bg-white rounded-2xl p-12 shadow-2xl border border-gray-100 max-w-md">
//           <div className="w-20 h-20 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-6">
//             <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
//             </svg>
//           </div>
//           <h2 className="text-2xl font-bold text-gray-800 mb-4">Login Required</h2>
//           <p className="text-gray-600 mb-6">Please login to proceed with checkout</p>
//           <Link to="/login" className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-3 rounded-xl font-semibold hover:from-blue-700 hover:to-purple-700 transition-all duration-300 transform hover:scale-105">
//             Login Now
//           </Link>
//         </div>
//       </div>
//     );
//   }

//   if (loading) {
//     return <LoadingSpinner size="lg" text="Loading checkout..." />;
//   }

//   if (cart.items.length === 0) {
//     return (
//       <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 flex items-center justify-center">
//         <div className="text-center bg-white rounded-2xl p-12 shadow-2xl border border-gray-100 max-w-md">
//           <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
//             <svg className="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-1.5 8H19" />
//             </svg>
//           </div>
//           <h2 className="text-2xl font-bold text-gray-800 mb-4">Cart is Empty</h2>
//           <p className="text-gray-600 mb-6">Add some items to your cart before checkout</p>
//           <Link to="/products" className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-3 rounded-xl font-semibold hover:from-blue-700 hover:to-purple-700 transition-all duration-300 transform hover:scale-105">
//             Shop Now
//           </Link>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
//       <div className="container mx-auto px-4 py-8">
//         <div className="text-center mb-8">
//           <h1 className="text-4xl font-bold bg-gradient-to-r from-gray-800 to-blue-600 bg-clip-text text-transparent mb-2">
//             Secure Checkout
//           </h1>
//           <p className="text-gray-600">Complete your purchase securely</p>
//         </div>
        
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
//           <div className="space-y-6">
//             <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100">
//               <h2 className="text-xl font-bold text-gray-800 mb-6 flex items-center">
//                 <svg className="w-6 h-6 text-blue-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
//                 </svg>
//                 Shipping Information
//               </h2>
//               <div className="space-y-4">
//                 <div>
//                   <label className="block text-sm font-bold text-gray-700 mb-2">Full Name</label>
//                   <input
//                     type="text"
//                     value={user.full_name}
//                     disabled
//                     className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl bg-gray-50 text-gray-600"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-sm font-bold text-gray-700 mb-2">Email Address</label>
//                   <input
//                     type="email"
//                     value={user.email}
//                     disabled
//                     className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl bg-gray-50 text-gray-600"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-sm font-bold text-gray-700 mb-2">Shipping Address *</label>
//                   <textarea
//                     value={shippingAddress}
//                     onChange={(e) => setShippingAddress(e.target.value)}
//                     placeholder="Enter your complete shipping address"
//                     rows="4"
//                     className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
          
//           <div className="space-y-6">
//             <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100">
//               <h2 className="text-xl font-bold text-gray-800 mb-6 flex items-center">
//                 <svg className="w-6 h-6 text-blue-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6-4h6m2 5.291A7.962 7.962 0 0112 15c-2.34 0-4.467-.881-6.08-2.33" />
//                 </svg>
//                 Order Summary
//               </h2>
//               <div className="space-y-4 mb-6">
//                 {cart.items.map((item, index) => (
//                   <div key={index} className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
//                     <div>
//                       <span className="font-medium text-gray-800">Product × {item.quantity}</span>
//                       <div className="text-sm text-gray-600">₹{item.price} each</div>
//                     </div>
//                     <span className="font-bold text-gray-800">₹{(item.quantity * item.price).toFixed(2)}</span>
//                   </div>
//                 ))}
//               </div>
//               <div className="border-t pt-4">
//                 <div className="flex justify-between items-center mb-4">
//                   <span className="text-xl font-bold text-gray-800">Total:</span>
//                   <span className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
//                     ₹{cart.total.toFixed(2)}
//                   </span>
//                 </div>
//               </div>
//             </div>
            
//             <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100">
//               <h2 className="text-xl font-bold text-gray-800 mb-6 flex items-center">
//                 <svg className="w-6 h-6 text-blue-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
//                 </svg>
//                 Payment Method
//               </h2>
//               <div className="mb-4 p-4 bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl border border-blue-100">
//                 <div className="flex items-center space-x-3 mb-2">
//                   <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiByeD0iOCIgZmlsbD0iIzAyOENEQiIvPgo8cGF0aCBkPSJNMTUuOTk5OCAxMy41VjE5LjVNMTUuOTk5OCAxMy41TDE5LjUgMTdNMTUuOTk5OCAxMy41TDEyLjUgMTciIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=" alt="Razorpay" className="w-8 h-8" />
//                   <span className="font-bold text-gray-800">Razorpay</span>
//                   <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full font-semibold">Secure</span>
//                 </div>
//                 <p className="text-sm text-gray-600">
//                   Pay securely using credit cards, debit cards, UPI, net banking and more
//                 </p>
//               </div>
              
//               <button
//                 onClick={initiatePayment}
//                 disabled={processing || !shippingAddress.trim()}
//                 className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-4 rounded-xl font-bold text-lg hover:from-blue-700 hover:to-purple-700 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
//               >
//                 {processing ? (
//                   <div className="flex items-center justify-center space-x-2">
//                     <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
//                     <span>Processing Payment...</span>
//                   </div>
//                 ) : (
//                   <div className="flex items-center justify-center space-x-2">
//                     <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
//                     </svg>
//                     <span>Pay ₹{cart.total.toFixed(2)} Securely</span>
//                   </div>
//                 )}
//               </button>
              
//               <div className="mt-4 text-center text-xs text-gray-500">
//                 <p>🔒 Demo Mode: This will simulate a payment flow</p>
//                 <p>Your data is secure and encrypted</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// Enhanced Orders Page and Admin Page would continue here...
// For brevity, I'll include the simplified versions

const OrdersPage = () => {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      fetchOrders();
    }
  }, [user]);

  const fetchOrders = async () => {
    try {
      const response = await axios.get(`${API}/orders`);
      setOrders(response.data);
    } catch (error) {
      console.error('Error fetching orders:', error);
    } finally {
      setLoading(false);
    }
  };

  if (!user) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 flex items-center justify-center">
        <div className="text-center bg-white rounded-2xl p-12 shadow-2xl border border-gray-100 max-w-md">
          <div className="w-20 h-20 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Login Required</h2>
          <p className="text-gray-600 mb-6">Please login to view your orders</p>
          <Link to="/login" className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-3 rounded-xl font-semibold hover:from-blue-700 hover:to-purple-700 transition-all duration-300 transform hover:scale-105">
            Login Now
          </Link>
        </div>
      </div>
    );
  }

  if (loading) {
    return <LoadingSpinner size="lg" text="Loading your orders..." />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="container mx-auto px-4 py-8">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold bg-gradient-to-r from-gray-800 to-blue-600 bg-clip-text text-transparent mb-2">
            My Orders
          </h1>
          <p className="text-gray-600">Track and manage your orders</p>
        </div>
        
        {orders.length === 0 ? (
          <div className="bg-white rounded-2xl p-12 text-center shadow-xl border border-gray-100 max-w-2xl mx-auto">
            <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <svg className="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9 12h6m-6-4h6m2 5.291A7.962 7.962 0 0112 15c-2.34 0-4.467-.881-6.08-2.33" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">No orders yet</h2>
            <p className="text-gray-600 mb-8">Start shopping to see your orders here!</p>
            <Link to="/products" className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-3 rounded-xl font-semibold hover:from-blue-700 hover:to-purple-700 transition-all duration-300 transform hover:scale-105">
              Start Shopping
            </Link>
          </div>
        ) : (
          <div className="space-y-6">
            {orders.map(order => (
              <div key={order.id} className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100 hover:shadow-2xl transition-all duration-300">
                <div className="flex justify-between items-start mb-6">
                  <div>
                    <h3 className="text-xl font-bold text-gray-800 mb-2">Order #{order.id.slice(-8)}</h3>
                    <p className="text-gray-600 flex items-center">
                      <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                      Placed on {new Date(order.created_at).toLocaleDateString()}
                    </p>
                  </div>
                  <div className="text-right">
                    <span className={`inline-block px-4 py-2 rounded-full text-sm font-bold ${
                      order.payment_status === 'paid' 
                        ? 'bg-green-100 text-green-800' 
                        : 'bg-yellow-100 text-yellow-800'
                    }`}>
                      {order.payment_status === 'paid' ? '✓ Paid' : '⏳ Pending'}
                    </span>
                    <p className="text-2xl font-bold text-gray-800 mt-2">₹{order.total}</p>
                  </div>
                </div>
                
                <div className="border-t pt-4">
                  <h4 className="font-bold text-gray-800 mb-3">Items ({order.items.length})</h4>
                  <div className="space-y-2">
                    {order.items.map((item, index) => (
                      <div key={index} className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
                        <span className="text-gray-700">Product × {item.quantity}</span>
                        <span className="font-semibold text-gray-800">₹{(item.quantity * item.price).toFixed(2)}</span>
                      </div>
                    ))}
                  </div>
                </div>
                
                <div className="border-t pt-4 mt-4">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                    <div>
                      <p className="text-gray-600">
                        <strong className="text-gray-800">Shipping Address:</strong><br />
                        {order.shipping_address}
                      </p>
                    </div>
                    <div>
                      <p className="text-gray-600">
                        <strong className="text-gray-800">Status:</strong> 
                        <span className="ml-1 capitalize font-semibold text-blue-600">{order.order_status}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

const AdminPage = () => {
  const { user, token } = useAuth();
  const [stats, setStats] = useState({});
  const [products, setProducts] = useState([]);
  const [orders, setOrders] = useState([]);
  const [activeTab, setActiveTab] = useState('dashboard');
  const [loading, setLoading] = useState(true);
  // In AdminPage, add state for modals and product form
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editProduct, setEditProduct] = useState(null);
  const [newProduct, setNewProduct] = useState({
    name: '',
    description: '',
    price: '',
    category: 'Fashion',
    gender: '',
    main_category: '',
    sub_category: '',
    colour: [],
    brand: '',
    fit: '',
    material: '',
    features: [],
    technology: '',
    best_for: '',
    sports: '',
    image_url: '',
    stock: ''
  });
  const [addError, setAddError] = useState('');
  const [editError, setEditError] = useState('');

  // Category Mapping
  const categoryMapping = {
    Men: {
      Topwear: ['T-Shirts', 'Casual Shirts', 'Formal Shirts', 'Sweatshirts', 'Sweaters', 'Jackets', 'Blazers & Coats', 'Suits', 'Rain Jackets'],
      'Indian & Festive Wear': ['Kurtas & Kurta Sets', 'Sherwanis', 'Nehru Jackets', 'Dhotis'],
      Bottomwear: ['Jeans', 'Casual Trousers', 'Formal Trousers', 'Shorts', 'Track Pants & Joggers'],
      'Innerwear & Sleepwear': ['Briefs & Trunks', 'Boxers', 'Vests', 'Sleepwear & Loungewear', 'Thermals'],
      'Sports & Active Wear': ['Active T-Shirts', 'Track Pants & Shorts', 'Tracksuits', 'Jackets & Sweatshirts', 'Swimwear'],
      'Fashion Accessories': ['Ties, Cufflinks & Pocket Squares', 'Caps & Hats', 'Mufflers, Scarves & Gloves']
    },
    Women: {
      'Indian & Fusion Wear': ['Kurtas & Suits', 'Kurtis, Tunics & Tops', 'Sarees', 'Ethnic Wear', 'Leggings, Salwars & Churidars', 'Skirts & Palazzos', 'Dress Materials', 'Lehenga Cholis', 'Dupattas & Shawls', 'Jackets'],
      'Western Wear': ['Dresses', 'Tops', 'Tshirts', 'Jeans', 'Trousers & Capris', 'Shorts & Skirts', 'Co-ords', 'Playsuits', 'Jumpsuits', 'Shrugs', 'Sweaters & Sweatshirts', 'Jackets & Coats', 'Blazers & Waistcoats'],
      Maternity: [],
      'Sports & Active Wear': ['Sports T-Shirts & Tops', 'Track Pants & Shorts', 'Tracksuits', 'Sports Jackets', 'Swimwear'],
      'Lingerie & Sleepwear': ['Bra', 'Briefs', 'Shapewear', 'Sleepwear & Loungewear', 'Swimwear', 'Camisoles & Thermals']
    },
    Kids: {
      'Boys Clothing': ['T-Shirts', 'Shirts', 'Shorts', 'Jeans', 'Trousers', 'Clothing Sets', 'Ethnic Wear', 'Track Pants & Pyjamas', 'Jacket, Sweater & Sweatshirts', 'Party Wear', 'Innerwear & Thermals', 'Nightwear & Loungewear', 'Value Packs'],
      'Girls Clothing': ['Dresses', 'Tops', 'Tshirts', 'Clothing Sets', 'Lehenga choli', 'Kurta Sets', 'Party wear', 'Dungarees & Jumpsuits', 'Skirts & shorts', 'Tights & Leggings', 'Jeans, Trousers & Capris', 'Jacket, Sweater & Sweatshirts', 'Innerwear & Thermals', 'Nightwear & Loungewear', 'Value Packs'],
      Infants: ['Bodysuits', 'Rompers & Sleepsuits', 'Clothing Sets', 'Tshirts & Tops', 'Dresses', 'Bottom wear', 'Winter Wear', 'Innerwear & Sleepwear'],
      Brands: ['H&M', 'Max Kids', 'Pantaloons', 'United Colors Of Benetton Kids', 'YK', 'U.S. Polo Assn. Kids', 'Mothercare', 'HRX']
    }
  };

  const colourOptions = ['Black', 'Blue', 'Brown', 'Green', 'Grey', 'Multi-Colour', 'Orange', 'Pink', 'Purple', 'Red', 'White', 'Yellow'];
  const fitOptions = ['Oversized', 'Loose', 'Standard', 'Slim', 'Tight'];
  const materialOptions = ['Cotton', 'Polyester', 'Fleece', 'Tech Fleece', 'Recycled Materials', 'InfinaSoft', 'Leather', 'Denim', 'Wool'];
  const technologyOptions = ['Dri-FIT', 'Dri-FIT ADV', 'Storm-FIT', 'Therma-FIT'];
  const bestForOptions = ['Winter Wear', 'Warm Weather', 'Wet Weather Conditions', 'Casual', 'Formal', 'Sports'];
  const sportsOptions = ['Lifestyle', 'Running', 'Football', 'Training & Gym', 'Basketball', 'Yoga', 'Cricket'];
  const featuresOptions = ['Vented', 'Drawcord', 'Longline', 'Non-Padded Cups', 'Hooded', 'Pockets', 'Zipper'];

  useEffect(() => {
    if (user?.role === 'admin') {
      fetchAdminData();
    }
  }, [user]);

  const fetchAdminData = async () => {
    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const [statsRes, productsRes, ordersRes] = await Promise.all([
        axios.get(`${API}/admin/stats`, config),
        axios.get(`${API}/products`, config),
        axios.get(`${API}/orders/admin/orders`, config)
      ]);
      setStats(statsRes.data);
      setProducts(productsRes.data);
      setOrders(ordersRes.data);
    } catch (error) {
      console.error('Error fetching admin data:', error);
    } finally {
      setLoading(false);
    }
  };

  // Add Product Handler
  const handleAddProduct = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        `${API}/products`,
        { ...newProduct, price: Number(newProduct.price), stock: Number(newProduct.stock) },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setShowAddModal(false);
      setNewProduct({ name: '', description: '', price: '', category: 'Fashion', gender: '', main_category: '', sub_category: '', colour: [], brand: '', fit: '', material: '', features: [], technology: '', best_for: '', sports: '', image_url: '', stock: '' });
      setAddError('');
      fetchAdminData(); // Refresh products
    } catch (err) {
      setAddError(err.response?.data?.message || 'Failed to add product');
    }
  };

  // Edit Product Handler
  const handleEditProduct = async (e) => {
    e.preventDefault();
    try {
      await axios.put(
        `${API}/products/${editProduct._id}`,
        { ...editProduct, price: Number(editProduct.price), stock: Number(editProduct.stock) },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setShowEditModal(false);
      setEditProduct(null);
      setEditError('');
      fetchAdminData(); // Refresh products
    } catch (err) {
      setEditError(err.response?.data?.message || 'Failed to update product');
    }
  };

  // Delete Product Handler
  const handleDeleteProduct = async (id) => {
    console.log('Delete clicked, ID:', id);
    const confirmed = window.confirm('Are you sure you want to delete this product?');
    console.log('Confirmation result:', confirmed);
    if (!confirmed) {
      console.log('Delete cancelled by user');
      return;
    }
    try {
      console.log('Sending delete request to:', `${API}/products/${id}`);
      const response = await axios.delete(`${API}/products/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      console.log('Delete response:', response);
      alert('Product deleted successfully!');
      fetchAdminData(); // Refresh products
    } catch (err) {
      console.error('Delete error:', err);
      console.error('Error response:', err.response);
      alert(err.response?.data?.message || 'Failed to delete product');
    }
  };

  if (!user) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 flex items-center justify-center">
        <div className="text-center bg-white rounded-2xl p-12 shadow-2xl border border-gray-100 max-w-md">
          <div className="w-20 h-20 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Admin Access Required</h2>
          <p className="text-gray-600 mb-6">Please login as admin to access dashboard</p>
          <Link to="/login" className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-3 rounded-xl font-semibold hover:from-blue-700 hover:to-purple-700 transition-all duration-300 transform hover:scale-105">
            Admin Login
          </Link>
        </div>
      </div>
    );
  }

  if (user.role !== 'admin') {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 flex items-center justify-center">
        <div className="text-center bg-white rounded-2xl p-12 shadow-2xl border border-gray-100 max-w-md">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-10 h-10 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Access Denied</h2>
          <p className="text-gray-600 mb-6">You don't have admin privileges</p>
          <Link to="/" className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-3 rounded-xl font-semibold hover:from-blue-700 hover:to-purple-700 transition-all duration-300 transform hover:scale-105">
            Go Home
          </Link>
        </div>
      </div>
    );
  }

  if (loading) {
    return <LoadingSpinner size="lg" text="Loading admin dashboard..." />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="container mx-auto px-4 py-8">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold bg-gradient-to-r from-gray-800 to-blue-600 bg-clip-text text-transparent mb-2">
            Admin Dashboard
          </h1>
          <p className="text-gray-600">Manage your Francium store</p>
        </div>
        
        {/* Navigation Tabs */}
        <div className="bg-white rounded-2xl shadow-xl mb-8 border border-gray-100 overflow-hidden">
          <div className="flex border-b border-gray-100">
            {[
              { id: 'dashboard', label: 'Dashboard', icon: '📊' },
              { id: 'products', label: 'Products', icon: '📦' },
              { id: 'orders', label: 'Orders', icon: '🛍️' }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex-1 px-6 py-4 font-bold transition-all duration-300 ${
                  activeTab === tab.id
                    ? 'bg-gradient-to-r from-blue-50 to-purple-50 text-blue-600 border-b-2 border-blue-600'
                    : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
                }`}
              >
                <span className="mr-2">{tab.icon}</span>
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* Dashboard Tab */}
        {activeTab === 'dashboard' && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { label: 'Total Products', value: stats.total_products || 0, color: 'blue', icon: '📦' },
              { label: 'Total Orders', value: stats.total_orders || 0, color: 'green', icon: '🛍️' },
              { label: 'Total Users', value: stats.total_users || 0, color: 'purple', icon: '👥' },
              { label: 'Total Revenue', value: `₹${stats.total_revenue || 0}`, color: 'red', icon: '💰' }
            ].map((stat, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:scale-105">
                <div className="flex items-center justify-between mb-4">
                  <div className={`text-3xl p-3 rounded-xl bg-${stat.color}-50`}>
                    {stat.icon}
                  </div>
                  <div className={`text-${stat.color}-600 text-sm font-semibold`}>
                    +12% from last month
                  </div>
                </div>
                <h3 className="text-lg font-bold text-gray-700 mb-2">{stat.label}</h3>
                <p className={`text-3xl font-bold text-${stat.color}-600`}>{stat.value}</p>
              </div>
            ))}
          </div>
        )}

        {/* Products Tab */}
        {activeTab === 'products' && (
          <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
            <div className="p-6 bg-gradient-to-r from-blue-50 to-purple-50 border-b border-gray-100 flex justify-between items-center">
              <h2 className="text-xl font-bold text-gray-800">Product Management</h2>
              <button
                className="bg-blue-600 text-white px-4 py-2 rounded font-bold"
                onClick={() => setShowAddModal(true)}
              >
                Add Product
              </button>
            </div>
            <div className="p-6">
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead>
                    <tr className="bg-gray-50 border-b border-gray-200">
                      <th className="px-4 py-3 text-left font-bold text-gray-700">Name</th>
                      <th className="px-4 py-3 text-left font-bold text-gray-700">Category</th>
                      <th className="px-4 py-3 text-left font-bold text-gray-700">Price</th>
                      <th className="px-4 py-3 text-left font-bold text-gray-700">Stock</th>
                      <th className="px-4 py-3 text-left font-bold text-gray-700">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {products.map(product => (
                      <tr key={product._id} className="border-b border-gray-100 hover:bg-gray-50 transition-colors">
                        <td className="px-4 py-4 font-semibold text-gray-800">{product.name}</td>
                        <td className="px-4 py-4">
                          <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-xs font-semibold">
                            {product.category}
                          </span>
                        </td>
                        <td className="px-4 py-4 font-bold text-gray-800">₹{product.price}</td>
                        <td className="px-4 py-4">
                          <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
                            product.stock > 10
                              ? 'bg-green-100 text-green-800'
                              : product.stock > 0
                                ? 'bg-yellow-100 text-yellow-800'
                                : 'bg-red-100 text-red-800'
                          }`}>
                            {product.stock}
                          </span>
                        </td>
                        <td className="px-4 py-4">
                          <div className="flex space-x-2">
                            <button
                              className="text-blue-600 hover:text-blue-800 hover:bg-blue-50 px-2 py-1 rounded transition-colors text-sm font-medium"
                              onClick={() => { setEditProduct({ ...product }); setShowEditModal(true); }}
                            >
                              Edit
                            </button>
                            <button
                              className="text-red-600 hover:text-red-800 hover:bg-red-50 px-2 py-1 rounded transition-colors text-sm font-medium"
                              onClick={() => handleDeleteProduct(product._id)}
                            >
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            {/* Add Product Modal */}
            {showAddModal && (
              <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50 overflow-y-auto">
                <div className="bg-white p-8 rounded shadow-lg w-full max-w-2xl my-8 max-h-[90vh] overflow-y-auto">
                  <h2 className="text-xl font-bold mb-4">Add Product</h2>
                  {addError && <div className="text-red-600 mb-2">{addError}</div>}
                  <form onSubmit={handleAddProduct} className="space-y-3">
                    <div className="grid grid-cols-2 gap-3">
                      <input className="w-full border p-2 rounded" placeholder="Product Name" value={newProduct.name} onChange={e => setNewProduct({ ...newProduct, name: e.target.value })} required />
                      <input className="w-full border p-2 rounded" placeholder="Brand" value={newProduct.brand} onChange={e => setNewProduct({ ...newProduct, brand: e.target.value })} />
                    </div>
                    <textarea className="w-full border p-2 rounded" placeholder="Description" rows="3" value={newProduct.description} onChange={e => setNewProduct({ ...newProduct, description: e.target.value })} required />
                    
                    <div className="grid grid-cols-2 gap-3">
                      <input className="w-full border p-2 rounded" placeholder="Price (₹)" type="number" value={newProduct.price} onChange={e => setNewProduct({ ...newProduct, price: e.target.value })} required />
                      <input className="w-full border p-2 rounded" placeholder="Stock" type="number" value={newProduct.stock} onChange={e => setNewProduct({ ...newProduct, stock: e.target.value })} required />
                    </div>

                    <div className="border-t pt-3 mt-3">
                      <h3 className="font-semibold mb-2">Category Information</h3>
                      <div className="grid grid-cols-3 gap-3">
                        <div>
                          <label className="block text-sm font-medium mb-1">Gender *</label>
                          <select className="w-full border p-2 rounded" value={newProduct.gender} onChange={e => setNewProduct({ ...newProduct, gender: e.target.value, main_category: '', sub_category: '' })} required>
                            <option value="">Select</option>
                            <option value="Men">Men</option>
                            <option value="Women">Women</option>
                            <option value="Kids">Kids</option>
                            <option value="Unisex">Unisex</option>
                          </select>
                        </div>
                        <div>
                          <label className="block text-sm font-medium mb-1">Main Category *</label>
                          <select className="w-full border p-2 rounded" value={newProduct.main_category} onChange={e => setNewProduct({ ...newProduct, main_category: e.target.value, sub_category: '' })} required disabled={!newProduct.gender || newProduct.gender === 'Unisex'}>
                            <option value="">Select</option>
                            {newProduct.gender && newProduct.gender !== 'Unisex' && categoryMapping[newProduct.gender] && Object.keys(categoryMapping[newProduct.gender]).map(cat => (
                              <option key={cat} value={cat}>{cat}</option>
                            ))}
                          </select>
                        </div>
                        <div>
                          <label className="block text-sm font-medium mb-1">Sub Category</label>
                          <select className="w-full border p-2 rounded" value={newProduct.sub_category} onChange={e => setNewProduct({ ...newProduct, sub_category: e.target.value })} disabled={!newProduct.main_category}>
                            <option value="">Select</option>
                            {newProduct.gender && newProduct.main_category && categoryMapping[newProduct.gender]?.[newProduct.main_category]?.map(subcat => (
                              <option key={subcat} value={subcat}>{subcat}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="border-t pt-3 mt-3">
                      <h3 className="font-semibold mb-2">Filter Attributes</h3>
                      <div className="grid grid-cols-2 gap-3">
                        <div>
                          <label className="block text-sm font-medium mb-1">Colour (Select multiple)</label>
                          <select multiple className="w-full border p-2 rounded h-24" value={newProduct.colour} onChange={e => setNewProduct({ ...newProduct, colour: Array.from(e.target.selectedOptions, option => option.value) })}>
                            {colourOptions.map(color => (
                              <option key={color} value={color}>{color}</option>
                            ))}
                          </select>
                        </div>
                        <div>
                          <label className="block text-sm font-medium mb-1">Fit</label>
                          <select className="w-full border p-2 rounded" value={newProduct.fit} onChange={e => setNewProduct({ ...newProduct, fit: e.target.value })}>
                            <option value="">Select</option>
                            {fitOptions.map(fit => (
                              <option key={fit} value={fit}>{fit}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                      
                      <div className="grid grid-cols-2 gap-3 mt-3">
                        <div>
                          <label className="block text-sm font-medium mb-1">Material</label>
                          <select className="w-full border p-2 rounded" value={newProduct.material} onChange={e => setNewProduct({ ...newProduct, material: e.target.value })}>
                            <option value="">Select</option>
                            {materialOptions.map(material => (
                              <option key={material} value={material}>{material}</option>
                            ))}
                          </select>
                        </div>
                        <div>
                          <label className="block text-sm font-medium mb-1">Technology</label>
                          <select className="w-full border p-2 rounded" value={newProduct.technology} onChange={e => setNewProduct({ ...newProduct, technology: e.target.value })}>
                            <option value="">Select</option>
                            {technologyOptions.map(tech => (
                              <option key={tech} value={tech}>{tech}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                      
                      <div className="grid grid-cols-2 gap-3 mt-3">
                        <div>
                          <label className="block text-sm font-medium mb-1">Best For</label>
                          <select className="w-full border p-2 rounded" value={newProduct.best_for} onChange={e => setNewProduct({ ...newProduct, best_for: e.target.value })}>
                            <option value="">Select</option>
                            {bestForOptions.map(best => (
                              <option key={best} value={best}>{best}</option>
                            ))}
                          </select>
                        </div>
                        <div>
                          <label className="block text-sm font-medium mb-1">Sports</label>
                          <select className="w-full border p-2 rounded" value={newProduct.sports} onChange={e => setNewProduct({ ...newProduct, sports: e.target.value })}>
                            <option value="">Select</option>
                            {sportsOptions.map(sport => (
                              <option key={sport} value={sport}>{sport}</option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="mt-3">
                        <label className="block text-sm font-medium mb-1">Features (Select multiple)</label>
                        <select multiple className="w-full border p-2 rounded h-20" value={newProduct.features} onChange={e => setNewProduct({ ...newProduct, features: Array.from(e.target.selectedOptions, option => option.value) })}>
                          {featuresOptions.map(feature => (
                            <option key={feature} value={feature}>{feature}</option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium mb-2">Product Image *</label>
                      <input 
                        type="file" 
                        accept="image/*"
                        className="w-full border p-2 rounded" 
                        onChange={e => {
                          const file = e.target.files[0];
                          if (file) {
                            const reader = new FileReader();
                            reader.onload = (event) => {
                              const img = new Image();
                              img.onload = () => {
                                const canvas = document.createElement('canvas');
                                let width = img.width;
                                let height = img.height;
                                const maxSize = 800;
                                if (width > height && width > maxSize) {
                                  height = (height * maxSize) / width;
                                  width = maxSize;
                                } else if (height > maxSize) {
                                  width = (width * maxSize) / height;
                                  height = maxSize;
                                }
                                canvas.width = width;
                                canvas.height = height;
                                const ctx = canvas.getContext('2d');
                                ctx.drawImage(img, 0, 0, width, height);
                                const compressedBase64 = canvas.toDataURL('image/jpeg', 0.7);
                                setNewProduct({ ...newProduct, image_url: compressedBase64 });
                              };
                              img.src = event.target.result;
                            };
                            reader.readAsDataURL(file);
                          }
                        }} 
                        required 
                      />
                      {newProduct.image_url && (
                        <img src={newProduct.image_url} alt="Preview" className="mt-2 w-32 h-32 object-cover rounded" />
                      )}
                    </div>
                    
                    <div className="flex justify-end space-x-2 pt-3">
                      <button type="button" onClick={() => setShowAddModal(false)} className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300">Cancel</button>
                      <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">Add Product</button>
                    </div>
                  </form>
                </div>
              </div>
            )}
            {/* Edit Product Modal */}
            {showEditModal && editProduct && (
              <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50 overflow-y-auto">
                <div className="bg-white p-8 rounded shadow-lg w-full max-w-2xl my-8 max-h-[90vh] overflow-y-auto">
                  <h2 className="text-xl font-bold mb-4">Edit Product</h2>
                  {editError && <div className="text-red-600 mb-2">{editError}</div>}
                  <form onSubmit={handleEditProduct} className="space-y-3">
                    <div className="grid grid-cols-2 gap-3">
                      <input className="w-full border p-2 rounded" placeholder="Product Name" value={editProduct.name || ''} onChange={e => setEditProduct({ ...editProduct, name: e.target.value })} required />
                      <input className="w-full border p-2 rounded" placeholder="Brand" value={editProduct.brand || ''} onChange={e => setEditProduct({ ...editProduct, brand: e.target.value })} />
                    </div>
                    <textarea className="w-full border p-2 rounded" placeholder="Description" rows="3" value={editProduct.description || ''} onChange={e => setEditProduct({ ...editProduct, description: e.target.value })} required />
                    
                    <div className="grid grid-cols-2 gap-3">
                      <input className="w-full border p-2 rounded" placeholder="Price (₹)" type="number" value={editProduct.price || ''} onChange={e => setEditProduct({ ...editProduct, price: e.target.value })} required />
                      <input className="w-full border p-2 rounded" placeholder="Stock" type="number" value={editProduct.stock || ''} onChange={e => setEditProduct({ ...editProduct, stock: e.target.value })} required />
                    </div>

                    <div className="border-t pt-3 mt-3">
                      <h3 className="font-semibold mb-2">Category Information</h3>
                      <div className="grid grid-cols-3 gap-3">
                        <div>
                          <label className="block text-sm font-medium mb-1">Gender *</label>
                          <select className="w-full border p-2 rounded" value={editProduct.gender || ''} onChange={e => setEditProduct({ ...editProduct, gender: e.target.value, main_category: '', sub_category: '' })} required>
                            <option value="">Select</option>
                            <option value="Men">Men</option>
                            <option value="Women">Women</option>
                            <option value="Kids">Kids</option>
                            <option value="Unisex">Unisex</option>
                          </select>
                        </div>
                        <div>
                          <label className="block text-sm font-medium mb-1">Main Category *</label>
                          <select className="w-full border p-2 rounded" value={editProduct.main_category || ''} onChange={e => setEditProduct({ ...editProduct, main_category: e.target.value, sub_category: '' })} required disabled={!editProduct.gender || editProduct.gender === 'Unisex'}>
                            <option value="">Select</option>
                            {editProduct.gender && editProduct.gender !== 'Unisex' && categoryMapping[editProduct.gender] && Object.keys(categoryMapping[editProduct.gender]).map(cat => (
                              <option key={cat} value={cat}>{cat}</option>
                            ))}
                          </select>
                        </div>
                        <div>
                          <label className="block text-sm font-medium mb-1">Sub Category</label>
                          <select className="w-full border p-2 rounded" value={editProduct.sub_category || ''} onChange={e => setEditProduct({ ...editProduct, sub_category: e.target.value })} disabled={!editProduct.main_category}>
                            <option value="">Select</option>
                            {editProduct.gender && editProduct.main_category && categoryMapping[editProduct.gender]?.[editProduct.main_category]?.map(subcat => (
                              <option key={subcat} value={subcat}>{subcat}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="border-t pt-3 mt-3">
                      <h3 className="font-semibold mb-2">Filter Attributes</h3>
                      <div className="grid grid-cols-2 gap-3">
                        <div>
                          <label className="block text-sm font-medium mb-1">Colour (Select multiple)</label>
                          <select multiple className="w-full border p-2 rounded h-24" value={editProduct.colour || []} onChange={e => setEditProduct({ ...editProduct, colour: Array.from(e.target.selectedOptions, option => option.value) })}>
                            {colourOptions.map(color => (
                              <option key={color} value={color}>{color}</option>
                            ))}
                          </select>
                        </div>
                        <div>
                          <label className="block text-sm font-medium mb-1">Fit</label>
                          <select className="w-full border p-2 rounded" value={editProduct.fit || ''} onChange={e => setEditProduct({ ...editProduct, fit: e.target.value })}>
                            <option value="">Select</option>
                            {fitOptions.map(fit => (
                              <option key={fit} value={fit}>{fit}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                      
                      <div className="grid grid-cols-2 gap-3 mt-3">
                        <div>
                          <label className="block text-sm font-medium mb-1">Material</label>
                          <select className="w-full border p-2 rounded" value={editProduct.material || ''} onChange={e => setEditProduct({ ...editProduct, material: e.target.value })}>
                            <option value="">Select</option>
                            {materialOptions.map(material => (
                              <option key={material} value={material}>{material}</option>
                            ))}
                          </select>
                        </div>
                        <div>
                          <label className="block text-sm font-medium mb-1">Technology</label>
                          <select className="w-full border p-2 rounded" value={editProduct.technology || ''} onChange={e => setEditProduct({ ...editProduct, technology: e.target.value })}>
                            <option value="">Select</option>
                            {technologyOptions.map(tech => (
                              <option key={tech} value={tech}>{tech}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                      
                      <div className="grid grid-cols-2 gap-3 mt-3">
                        <div>
                          <label className="block text-sm font-medium mb-1">Best For</label>
                          <select className="w-full border p-2 rounded" value={editProduct.best_for || ''} onChange={e => setEditProduct({ ...editProduct, best_for: e.target.value })}>
                            <option value="">Select</option>
                            {bestForOptions.map(best => (
                              <option key={best} value={best}>{best}</option>
                            ))}
                          </select>
                        </div>
                        <div>
                          <label className="block text-sm font-medium mb-1">Sports</label>
                          <select className="w-full border p-2 rounded" value={editProduct.sports || ''} onChange={e => setEditProduct({ ...editProduct, sports: e.target.value })}>
                            <option value="">Select</option>
                            {sportsOptions.map(sport => (
                              <option key={sport} value={sport}>{sport}</option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="mt-3">
                        <label className="block text-sm font-medium mb-1">Features (Select multiple)</label>
                        <select multiple className="w-full border p-2 rounded h-20" value={editProduct.features || []} onChange={e => setEditProduct({ ...editProduct, features: Array.from(e.target.selectedOptions, option => option.value) })}>
                          {featuresOptions.map(feature => (
                            <option key={feature} value={feature}>{feature}</option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium mb-2">Product Image</label>
                      <input 
                        type="file" 
                        accept="image/*"
                        className="w-full border p-2 rounded" 
                        onChange={e => {
                          const file = e.target.files[0];
                          if (file) {
                            const reader = new FileReader();
                            reader.onload = (event) => {
                              const img = new Image();
                              img.onload = () => {
                                const canvas = document.createElement('canvas');
                                let width = img.width;
                                let height = img.height;
                                const maxSize = 800;
                                if (width > height && width > maxSize) {
                                  height = (height * maxSize) / width;
                                  width = maxSize;
                                } else if (height > maxSize) {
                                  width = (width * maxSize) / height;
                                  height = maxSize;
                                }
                                canvas.width = width;
                                canvas.height = height;
                                const ctx = canvas.getContext('2d');
                                ctx.drawImage(img, 0, 0, width, height);
                                const compressedBase64 = canvas.toDataURL('image/jpeg', 0.7);
                                setEditProduct({ ...editProduct, image_url: compressedBase64 });
                              };
                              img.src = event.target.result;
                            };
                            reader.readAsDataURL(file);
                          }
                        }} 
                      />
                      {editProduct.image_url && (
                        <img src={editProduct.image_url} alt="Preview" className="mt-2 w-32 h-32 object-cover rounded" />
                      )}
                    </div>
                    
                    <div className="flex justify-end space-x-2 pt-3">
                      <button type="button" onClick={() => { setShowEditModal(false); setEditProduct(null); }} className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300">Cancel</button>
                      <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">Update Product</button>
                    </div>
                  </form>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Orders Tab */}
        {activeTab === 'orders' && (
          <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
            <div className="p-6 bg-gradient-to-r from-blue-50 to-purple-50 border-b border-gray-100">
              <h2 className="text-xl font-bold text-gray-800">Order Management</h2>
              <p className="text-gray-600">Track and manage customer orders</p>
            </div>
            <div className="p-6">
              <div className="space-y-4">
                {orders.map(order => (
                  <div key={order.id} className="border border-gray-100 rounded-xl p-4 hover:shadow-lg transition-all duration-300">
                    <div className="flex justify-between items-start">
                      <div>
                        <h3 className="font-bold text-lg text-gray-800">Order #{order.id.slice(-8)}</h3>
                        <p className="text-sm text-gray-600 flex items-center mt-1">
                          <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                          </svg>
                          {new Date(order.created_at).toLocaleDateString()}
                        </p>
                        <p className="text-sm text-gray-600 mt-1">
                          <strong>Items:</strong> {order.items.length} | 
                          <strong className="ml-2">Customer ID:</strong> {order.user_id.slice(-8)}
                        </p>
                      </div>
                      <div className="text-right">
                        <p className="font-bold text-xl text-gray-800 mb-2">₹{order.total}</p>
                        <span className={`inline-block px-3 py-1 rounded-full text-xs font-bold ${
                          order.payment_status === 'paid' 
                            ? 'bg-green-100 text-green-800' 
                            : 'bg-yellow-100 text-yellow-800'
                        }`}>
                          {order.payment_status}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

// Add a custom context and hook for cart refresh
const CartRefreshContext = createContext();
const CartRefreshProvider = ({ children }) => {
  const [cartRefreshKey, setCartRefreshKey] = useState(0);
  const refreshCart = () => setCartRefreshKey(k => k + 1);
  return (
    <CartRefreshContext.Provider value={{ cartRefreshKey, refreshCart }}>
      {children}
    </CartRefreshContext.Provider>
  );
};
export const useCartRefresh = () => useContext(CartRefreshContext);

// Footer Component
const Footer = () => {
  return (
    <footer className="bg-black text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* About Section */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-xl">H</span>
              </div>
              <h3 className="text-2xl font-bold text-white">House of PM</h3>
            </div>
            <p className="text-gray-400 leading-relaxed">
              Your ultimate destination for premium electronics, fashion, and lifestyle products. Quality you can trust, prices you'll love.
            </p>
            <div className="flex space-x-4 pt-2">
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-blue-600 rounded-full flex items-center justify-center transition-all duration-300 transform hover:scale-110">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-blue-400 rounded-full flex items-center justify-center transition-all duration-300 transform hover:scale-110">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/></svg>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-pink-600 rounded-full flex items-center justify-center transition-all duration-300 transform hover:scale-110">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"/></svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-400 hover:text-blue-400 transition-colors duration-300">Home</Link></li>
              <li><Link to="/products" className="text-gray-400 hover:text-blue-400 transition-colors duration-300">All Products</Link></li>
              <li><Link to="/cart" className="text-gray-400 hover:text-blue-400 transition-colors duration-300">Shopping Cart</Link></li>
              <li><Link to="/orders" className="text-gray-400 hover:text-blue-400 transition-colors duration-300">My Orders</Link></li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Customer Service</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-400 hover:text-blue-400 transition-colors duration-300">Contact Us</a></li>
              <li><a href="#" className="text-gray-400 hover:text-blue-400 transition-colors duration-300">Shipping Policy</a></li>
              <li><a href="#" className="text-gray-400 hover:text-blue-400 transition-colors duration-300">Returns & Exchanges</a></li>
              <li><a href="#" className="text-gray-400 hover:text-blue-400 transition-colors duration-300">FAQs</a></li>
              <li><a href="#" className="text-gray-400 hover:text-blue-400 transition-colors duration-300">Track Order</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Get In Touch</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <svg className="w-5 h-5 text-blue-400 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span className="text-gray-400">123 Commerce Street, Mumbai, India</span>
              </li>
              <li className="flex items-center space-x-3">
                <svg className="w-5 h-5 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <a href="mailto:support@francium.com" className="text-gray-400 hover:text-blue-400 transition-colors duration-300">support@francium.com</a>
              </li>
              <li className="flex items-center space-x-3">
                <svg className="w-5 h-5 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <a href="tel:+911234567890" className="text-gray-400 hover:text-blue-400 transition-colors duration-300">+91 123 456 7890</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-500 text-sm">
              © {new Date().getFullYear()} House of PM. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <a href="#" className="text-gray-500 hover:text-blue-400 text-sm transition-colors duration-300">Privacy Policy</a>
              <a href="#" className="text-gray-500 hover:text-blue-400 text-sm transition-colors duration-300">Terms of Service</a>
              <a href="#" className="text-gray-500 hover:text-blue-400 text-sm transition-colors duration-300">Cookie Policy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

// Main App Component with Enhanced Routing
function App() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin') || location.pathname === '/checkout';

  return (
    <CartRefreshProvider>
      <AuthProvider>
        <div className="App">
          {!isAdminRoute && <Navbar />}
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/product/:id" element={<ProductDetailsPage useAuth={useAuth} useCartRefresh={useCartRefresh} API={API} />} />
            <Route path="/topwear" element={<Topwear />} />
            <Route path="/indian-wear" element={<IndianWear />} />
            <Route path="/bottomwear" element={<Bottomwear />} />
            <Route path="/sports-wear" element={<SportsWear />} />
            <Route path="/fashion-accessories" element={<FashionAccessories />} />
            <Route path="/innerwear-sleepwear" element={<InnerwearSleepwear />} />
            <Route path="/indian-fusion-wear" element={<IndianFusionWear />} />
            <Route path="/western-wear" element={<WesternWear />} />
            <Route path="/lingerie-sleepwear" element={<LingerieSleepwear />} />
            <Route path="/sports-active-wear" element={<SportsActiveWear />} />
            <Route path="/women-fashion-accessories" element={<WomenFashionAccessories />} />
            <Route path="/boys-clothing" element={<BoysClothing />} />
            <Route path="/girls-clothing" element={<GirlsClothing />} />
            <Route path="/infants" element={<InfantsClothing />} />
            
            {/* Men's Topwear Subcategories */}
            <Route path="/mens/topwear/tshirts" element={<TShirts />} />
            <Route path="/mens/topwear/casual-shirts" element={<CasualShirts />} />
            <Route path="/mens/topwear/formal-shirts" element={<FormalShirts />} />
            <Route path="/mens/topwear/sweatshirts" element={<Sweatshirts />} />
            <Route path="/mens/topwear/sweaters" element={<Sweaters />} />
            <Route path="/mens/topwear/jackets" element={<Jackets />} />
            <Route path="/mens/topwear/suits" element={<Suits />} />
            <Route path="/mens/topwear/blazers-coats" element={<BlazersCoats />} />
            <Route path="/mens/topwear/rain-jackets" element={<RainJackets />} />
            
            {/* Men's Bottomwear Subcategories */}
            <Route path="/mens/bottomwear/jeans" element={<Jeans />} />
            <Route path="/mens/bottomwear/casual-trousers" element={<CasualTrousers />} />
            <Route path="/mens/bottomwear/formal-trousers" element={<FormalTrousers />} />
            <Route path="/mens/bottomwear/shorts" element={<Shorts />} />
            <Route path="/mens/bottomwear/track-pants-joggers" element={<TrackPantsJoggers />} />
            
            {/* Men's Indian & Festive Wear Subcategories */}
            <Route path="/mens/indian-wear/kurtas-kurta-sets" element={<KurtasKurtaSets />} />
            <Route path="/mens/indian-wear/sherwanis" element={<Sherwanis />} />
            <Route path="/mens/indian-wear/nehru-jackets" element={<NehruJackets />} />
            <Route path="/mens/indian-wear/dhotis" element={<Dhotis />} />
            
            {/* Men's Sports & Active Wear Subcategories */}
            <Route path="/mens/sports-active-wear/active-tshirts" element={<ActiveTShirts />} />
            <Route path="/mens/sports-active-wear/track-pants-shorts" element={<TrackPantsShorts />} />
            <Route path="/mens/sports-active-wear/tracksuits" element={<Tracksuits />} />
            <Route path="/mens/sports-active-wear/jackets-sweatshirts" element={<JacketsSweatshirts />} />
            <Route path="/mens/sports-active-wear/swimwear" element={<Swimwear />} />
            
            {/* Men's Innerwear & Sleepwear Subcategories */}
            <Route path="/mens/innerwear-sleepwear/briefs-trunks" element={<BriefsTrunks />} />
            <Route path="/mens/innerwear-sleepwear/boxers" element={<Boxers />} />
            <Route path="/mens/innerwear-sleepwear/vests" element={<Vests />} />
            <Route path="/mens/innerwear-sleepwear/sleepwear-loungewear" element={<SleepwearLoungewear />} />
            <Route path="/mens/innerwear-sleepwear/thermals" element={<Thermals />} />
            
            {/* Men's Fashion Accessories Subcategories */}
            <Route path="/mens/fashion-accessories/ties-cufflinks-pocket-squares" element={<TiesCufflinksPocketSquares />} />
            <Route path="/mens/fashion-accessories/caps-hats" element={<CapsHats />} />
            <Route path="/mens/fashion-accessories/mufflers-scarves-gloves" element={<MufflersScarvesGloves />} />
            
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/checkout" element={<PrivateRoute> 
              <CheckoutPage API={API}/></PrivateRoute>} />
            <Route path="/orders" element={<OrdersPage />} />
            
            {/* Admin Routes with Layout */}
            <Route path="/admin" element={<AdminLayout><AdminDashboard /></AdminLayout>} />
            <Route path="/admin/products" element={<AdminLayout><ProductManagement /></AdminLayout>} />
            <Route path="/admin/orders" element={<AdminLayout><OrderManagement /></AdminLayout>} />
            <Route path="/admin/users" element={<AdminLayout><UserManagement /></AdminLayout>} />
            <Route path="/admin/cache" element={<AdminLayout><CacheManagement /></AdminLayout>} />
            
            <Route path="*" element={<HomePage />} />
          </Routes>
          {!isAdminRoute && <Footer />}
        </div>
      </AuthProvider>
    </CartRefreshProvider>
  );
}

export default App;